export const AUTH_STORAGE_KEY = 'findex_auth'
